import { ParseJsonLogicOptions, RQBJsonLogic } from 'react-querybuilder';
import { parseJsonLogic as rqbParseJsonLogic } from 'react-querybuilder/parseJsonLogic';

import {
  type JsonLogic,
  jsonLogicOperationsExtended,
  type QueryBuilderRuleGroupType,
} from '@dotfile/shared/domain';

/**
 * Parses a JsonLogic object into a ReactQueryBuilder rule group
 *
 * @param jsonLogic - The JsonLogic object to parse
 * @param options - Options for parsing the JsonLogic object
 * @returns A QueryBuilder rule group that represents the JsonLogic
 * @see https://react-querybuilder.js.org/docs/utils/import#jsonlogic
 * @see https://jsonlogic.com/
 */
export const parseJsonLogic = (
  jsonLogic: JsonLogic,
  options: Omit<
    ParseJsonLogicOptions,
    'independentCombinators' | 'jsonLogicOperations'
  > = {},
): QueryBuilderRuleGroupType =>
  rqbParseJsonLogic(
    // Need top cast since our JsonLogic is not compatible with RQBJsonLogic
    // Because of the extended operators
    jsonLogic as RQBJsonLogic,
    {
      ...options,
      jsonLogicOperations: jsonLogicOperationsExtended,
    },
  ) as QueryBuilderRuleGroupType;
